import { render } from "./SubmitYourApp.vue?vue&type=template&id=582a8d03&scoped=true"
import script from "./SubmitYourApp.vue?vue&type=script&lang=js"
export * from "./SubmitYourApp.vue?vue&type=script&lang=js"

import "./SubmitYourApp.vue?vue&type=style&index=0&id=582a8d03&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582a8d03"]])

export default __exports__